import React from 'react';
import '../Utilities/reset.css';
import './Link2.css';

function Link2(props) {
    return (
        <div className="home-container2">
            <section className="home-section2">
                Hello from Link2
            </section>
        </div>
    );
}

export default Link2;